import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var sectionThemeWeb = {
  descriptionColor: colors.octoberGrey
};

var sectionDarkThemeWeb = _extends({}, sectionThemeWeb, {
  descriptionColor: colors.fogGrey
});

export { sectionDarkThemeWeb, sectionThemeWeb };